export const OFFLINE_CREATE_FILE_DB_INFO = {
  dbName: 'OfflinePhotosDB',
  objectStoreName: 'OfflineFiles',
} as const;
